var React = require('react');

function IconQ (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M114.82 125.052L80.4238 90.6564L90.3054 80.7747L124.701 115.171L114.82 125.052ZM54.2437 83C54.2437 67.1437 67.1438 53.975 83.2688 53.975C99.3937 53.975 112.025 67.1437 112.025 83C112.025 83 112.025 83 112.025 83.2687H126C126 83.2687 126 83.2687 126 83C126 59.35 106.65 40 83 40C59.35 40 40 59.35 40 83C40 106.65 59.0812 126 82.7313 126V112.025C66.875 111.756 54.2437 98.8562 54.2437 83Z"}));
}

IconQ.defaultProps = {"width":"166","height":"165","viewBox":"0 0 166 165","fill":"none"};

module.exports = IconQ;

IconQ.default = IconQ;
